import dynamic from 'next/dynamic';

import { useCalendarEventsDates } from '@components/DatePicker/useCalendarEventsDates';
import { useDevice } from '@contexts/device';
import { CheckAvailabilityViewModel } from '@api/v3';

import { useHotelAvailableDates } from './hooks';

const MobileAvailableRoomDates = dynamic(
  () => import('./MobileAvailableRoomDates')
);
const DesktopAvailableRoomDates = dynamic(
  () => import('./DesktopAvailableRoomDates')
);

interface Props {
  availableDates?: CheckAvailabilityViewModel;
  isFetchingAvailableDates?: boolean;
}

const AvailableRoomDates = ({
  availableDates,
  isFetchingAvailableDates,
}: Props) => {
  const { isDesktop } = useDevice();
  const { events } = useCalendarEventsDates();
  const {
    startDate,
    endDate,
    setStartDate,
    setEndDate,
    setVisibleAvailableDates,
    visibleAvailableDates,
    handleSearch,
  } = useHotelAvailableDates();

  return isDesktop ? (
    <DesktopAvailableRoomDates
      data={availableDates}
      visibleAvailableDates={visibleAvailableDates}
      setVisibleAvailableDates={setVisibleAvailableDates}
      isFetching={Boolean(isFetchingAvailableDates)}
      events={events}
      startDate={startDate}
      endDate={endDate}
      setStartDate={setStartDate}
      setEndDate={setEndDate}
      handleSearch={handleSearch}
    />
  ) : (
    <MobileAvailableRoomDates
      data={availableDates}
      visibleAvailableDates={visibleAvailableDates}
      setVisibleAvailableDates={setVisibleAvailableDates}
      events={events}
      startDate={startDate}
      endDate={endDate}
      setStartDate={setStartDate}
      setEndDate={setEndDate}
      handleSearch={handleSearch}
    />
  );
};

export default AvailableRoomDates;
